import { createGtm } from "@gtm-support/vue-gtm";

export default defineNuxtPlugin(nuxtApp => {
	if (import.meta.client) {
		const { gtm } = useRuntimeConfig().public;
		window.dataLayer = window.dataLayer ?? [];

		(window as any).gtag =
			(window as any).gtag ||
			function () {
				// eslint-disable-next-line prefer-rest-params
				window.dataLayer?.push(arguments);
			};

		(window as any).gtag("consent", "default", {
			ad_storage: "denied",
			ad_user_data: "denied",
			ad_personalization: "denied",
			analytics_storage: "denied",
		});

		setTimeout(() => {
			nuxtApp.vueApp.use(
				createGtm({
					id: gtm.id,
					defer: true,
					enabled: true,
					debug: !import.meta.env.PROD,
					queryParams: {
						gtm_auth: gtm.gtm_auth,
						gtm_preview: "",
						gtm_cookies_win: "x",
					},
					vueRouter: useRouter(),
					loadScript: true,
					compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
					trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
				})
			);
		}, 10);
	}
});
